import { IAppointmentSlot } from '../models/public-provider-calendar.interface';

const TODAY = new Date(2024, 10, 1);
const TOMORROW = new Date(2024, 10, 3);
const DAY_AFTER_THAT = new Date(2024, 10, 6);
const A_WEEK_LATER = new Date(2024, 10, 7);
const AND_AFTER_THAT = new Date(2024, 10, 19);
const BUT_FURTHER_ON = new Date(2024, 10, 30);
const ALSO = new Date(2024, 11, 7);

export const TEST_APPOINTMENT_SLOTS: IAppointmentSlot[] = [
  {
    start: new Date(TODAY.setHours(2)),
    end: new Date(TODAY.setHours(3))
  },
  {
    start: new Date(TODAY.setHours(3)),
    end: new Date(TODAY.setHours(4))
  },
  {
    start: new Date(TODAY.setHours(4)),
    end: new Date(TODAY.setHours(5))
  },
  {
    start: new Date(TOMORROW.setHours(10)),
    end: new Date(TOMORROW.setHours(11))
  },
  {
    start: new Date(TOMORROW.setHours(7)),
    end: new Date(TOMORROW.setHours(8))
  },
  {
    start: new Date(TOMORROW.setHours(3)),
    end: new Date(TOMORROW.setHours(4))
  },
  {
    start: new Date(TOMORROW.setHours(4)),
    end: new Date(TOMORROW.setHours(5))
  },
  {
    start: new Date(TOMORROW.setHours(2)),
    end: new Date(TOMORROW.setHours(3))
  },
  {
    start: new Date(DAY_AFTER_THAT.setHours(3)),
    end: new Date(DAY_AFTER_THAT.setHours(4))
  },
  {
    start: new Date(TOMORROW.setHours(1)),
    end: new Date(TOMORROW.setHours(2))
  },
  {
    start: new Date(DAY_AFTER_THAT.setHours(4)),
    end: new Date(DAY_AFTER_THAT.setHours(5))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(2)),
    end: new Date(A_WEEK_LATER.setHours(3))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(3)),
    end: new Date(A_WEEK_LATER.setHours(4))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(4)),
    end: new Date(A_WEEK_LATER.setHours(5))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(5)),
    end: new Date(A_WEEK_LATER.setHours(6))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(6)),
    end: new Date(A_WEEK_LATER.setHours(7))
  },
  {
    start: new Date(A_WEEK_LATER.setHours(7)),
    end: new Date(A_WEEK_LATER.setHours(8))
  },
  {
    start: new Date(AND_AFTER_THAT.setHours(11)),
    end: new Date(AND_AFTER_THAT.setHours(12))
  },
  {
    start: new Date(BUT_FURTHER_ON.setHours(11)),
    end: new Date(BUT_FURTHER_ON.setHours(12))
  },
  {
    start: new Date(ALSO.setHours(11)),
    end: new Date(ALSO.setHours(12))
  }
];
